import axois from "axios";
import sender from "./sender";

// IDOM project service
export class FuncApiService {
  get url() {
    return "/api/function";
  }

  constructor(host) {
    this.http = axois.create({
      baseURL: host,
    });
  }

  get(method, params, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restGet(path, params, headers);
  }

  post(method, body, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restPost(path, body, headers);
  }

  patch(method, body, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restPatch(path, body, headers);
  }

  delete(method, params, headers = {}) {
    const path = `${this.url}/${method}`;
    return sender.restDel(path, params, headers);
  }

  generator_generate_topic(markers) {
    const method = `generator/generate/topic`;
    return this.post(method, { markers });
  }
  generator_generate_gpt_nofaq(text) {
    const method = `generator/generate/gpt/nofaq`;
    return this.post(method, { text });
  }
}
